export default __webpack_public_path__ + "static/media/AFM_rond_risicoscore4.ca98117a.jpg";